import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';

import {Contest} from './core/contest';

import 'rxjs/add/operator/toPromise';

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class DeathService {
    private deathUrl = 'https://williamherbert.org:1971/death';  // URL to web api
    constructor(private http: HttpClient) { }

    getAllContests (): Observable<Contest[]> {
        return this.http.get<Contest[]>(this.deathUrl + '/contest/all');
    }

    getContest(id: number): Observable<Contest> {
        return this.http.get<Contest>(this.deathUrl + '/contest/' + id);
    }

    getCurrentContest(): Observable<Contest> {
        return this.http.get<Contest>(this.deathUrl + '/contest/current');
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Users/william/Documents/gitlab/stovokor/src/app/death.service.ts